<div class="uploaded-images-wrapper" [class.medium]="medium" [class.disable-inner-scroll]="disableInnerScroll"
  [class.disable-paddings]="disablePaddings">
  <div pRipple class="uploaded-img-wrapper">
    @if (deleteAction) {
    <div class="delete-wrapper">
      <img class="delete-icon" src="./../../../../assets/images/icons/delete_forever.svg" alt="delete">
    </div>
    }
    <img class="uploaded-img" src="./../../../../assets/images/product/mock-images/Repair-Of-Modern-Car-Radiators 1.png"
      alt="uploaded-image">
  </div>

  <div pRipple class="uploaded-img-wrapper">
    @if (deleteAction) {
    <div class="delete-wrapper">
      <img class="delete-icon" src="./../../../../assets/images/icons/delete_forever.svg" alt="delete">
    </div>
    }
    <img class="uploaded-img" src="./../../../../assets/images/product/mock-images/Repair-Of-Modern-Car-Radiators 1.png"
      alt="uploaded-image">
  </div>

  <div pRipple class="uploaded-img-wrapper">
    @if (deleteAction) {
    <div class="delete-wrapper">
      <img class="delete-icon" src="./../../../../assets/images/icons/delete_forever.svg" alt="delete">
    </div>
    }
    <img class="uploaded-img" src="./../../../../assets/images/product/mock-images/Repair-Of-Modern-Car-Radiators 1.png"
      alt="uploaded-image">
  </div>

  <div pRipple class="uploaded-img-wrapper">
    @if (deleteAction) {
    <div class="delete-wrapper">
      <img class="delete-icon" src="./../../../../assets/images/icons/delete_forever.svg" alt="delete">
    </div>
    }
    <img class="uploaded-img" src="./../../../../assets/images/product/mock-images/Repair-Of-Modern-Car-Radiators 1.png"
      alt="uploaded-image">
  </div>

  <div pRipple class="uploaded-img-wrapper">
    @if (deleteAction) {
    <div class="delete-wrapper">
      <img class="delete-icon" src="./../../../../assets/images/icons/delete_forever.svg" alt="delete">
    </div>
    }
    <img class="uploaded-img" src="./../../../../assets/images/product/mock-images/Repair-Of-Modern-Car-Radiators 1.png"
      alt="uploaded-image">
  </div>

  <div pRipple class="uploaded-img-wrapper">
    @if (deleteAction) {
    <div class="delete-wrapper">
      <img class="delete-icon" src="./../../../../assets/images/icons/delete_forever.svg" alt="delete">
    </div>
    }
    <img class="uploaded-img" src="./../../../../assets/images/product/mock-images/Repair-Of-Modern-Car-Radiators 1.png"
      alt="uploaded-image">
  </div>
</div>
